import { Partner } from '../model/partner.model';

export const partners: Record<string, Partner> = {
    arenart: {
        name: 'Arenart',
        logoURL: 'arenart-logo.png',
        photo: 'arenart-photo.png',
        website: 'https://www.arenart.pl/',
        description: 'PARTNERS.arenart_description',
        availableLanguages: ['pl', 'en', 'de', 'sk'],
        stores: [
            {
                name: 'CH Złote Tarasy',
                country: 'Polska',
                postal_code: '',
                city: 'Warszawa',
                address: 'ul. Złota 59',
                open: {
                    week: '9:00-22:00',
                    saturday: '9:00-22:00',
                    sunday: '9:00-21:00',
                },
                emails: ['salon.zlotetarasy@arenart.pl'],
                phones: ['+48 884-884-525'],
            },
            {
                name: 'Westfield Arkadia',
                country: 'Polska',
                postal_code: '',
                city: 'Warszawa',
                address: 'al. Jana Pawła II 82',
                open: {
                    week: '10:00-22:00',
                    saturday: '10:00-22:00',
                    sunday: '10:00-21:00',
                },
                emails: ['salon.arkadia@arenart.pl'],
                phones: ['+48 884-884-544'],
            },
            {
                name: 'Westfield Mokotów',
                country: 'Polska',
                postal_code: '',
                city: 'Warszawa',
                address: 'ul. Wołoska 12',
                open: {
                    week: '10:00-22:00',
                    saturday: '10:00-22:00',
                    sunday: '10:00-21:00',
                },
                emails: ['salon.galeriamokotow@arenart.pl'],
                phones: ['+48 884-884-598'],
            },
        ],
    },
    schubert: {
        name: 'Jubiler Schubert',
        logoURL: 'schubert-logo.png',
        photo: 'schubert-photo.png',
        website: 'https://jubilerschubert.pl/',
        description: 'PARTNERS.schubert_description',
        availableLanguages: ['pl', 'en', 'de', 'sk'],
        stores: [
            {
                name: 'Janki',
                country: 'Polska',
                postal_code: '05-090',
                city: 'Warszawa',
                address: 'Mszczonowska 3',
                open: null,
                emails: ['janki@jubilerschubert.pl'],
                phones: ['+48 22 711 31 61', '+48 604 344 930'],
                links: [
                    {
                        name: 'PARTNERS.links.configurator',
                        url: 'https://jubilerschubert.pl/konfigurator-obraczek-slubnych',
                    },
                ],
            },
            {
                name: 'Jubilerska',
                country: 'Polska',
                postal_code: '04-190',
                city: 'Warszawa',
                address: 'Jubilerska 1/3',
                open: null,
                emails: ['jubilerska@jubilerjchubert.pl'],
                phones: ['+48 509 345 561', '+48 692 487 749'],
                links: [
                    {
                        name: 'PARTNERS.links.configurator',
                        url: 'https://jubilerschubert.pl/konfigurator-obraczek-slubnych',
                    },
                ],
            },
            {
                name: 'Reduta',
                country: 'Polska',
                postal_code: '02-325',
                city: 'Warszawa',
                address: 'Al. Jerozolimskie 148',
                open: null,
                emails: ['reduta@jubilerschubert.pl'],
                phones: ['+48 22 823 90 95', '+48 667 885 198'],
                links: [
                    {
                        name: 'PARTNERS.links.configurator',
                        url: 'https://jubilerschubert.pl/konfigurator-obraczek-slubnych',
                    },
                ],
            },
            {
                name: 'Tesco',
                country: 'Polska',
                postal_code: '01-460',
                city: 'Warszawa',
                address: 'Górczewska 212',
                open: null,
                emails: ['tescowwa@jubilerschubert.pl'],
                phones: ['+48 22 665 94 22', '+48 503 323 477'],
                links: [
                    {
                        name: 'PARTNERS.links.configurator',
                        url: 'https://jubilerschubert.pl/konfigurator-obraczek-slubnych',
                    },
                ],
            },
            {
                name: 'Serenada',
                country: 'Polska',
                postal_code: '31-876',
                city: 'Kraków',
                address: 'Bora Komorowskiego 41',
                open: null,
                emails: ['serenada@jubilerschubert.pl'],
                phones: ['+48 12 352 33 54', '+48 696 840 189'],
                links: [
                    {
                        name: 'PARTNERS.links.configurator',
                        url: 'https://jubilerschubert.pl/konfigurator-obraczek-slubnych',
                    },
                ],
            },
            {
                name: 'Targówek',
                country: 'Polska',
                postal_code: '03-287',
                city: 'Warszawa',
                address: 'Głębocka 15',
                open: null,
                emails: ['targowek@jubilerschubert.pl'],
                phones: ['+48 22 674 03 54', '+48 604 687 258'],
                links: [
                    {
                        name: 'PARTNERS.links.configurator',
                        url: 'https://jubilerschubert.pl/konfigurator-obraczek-slubnych',
                    },
                ],
            },
            {
                name: 'Morena',
                country: 'Polska',
                postal_code: '80-172',
                city: 'Gdańsk',
                address: 'Schuberta 102',
                open: null,
                emails: ['morena@jubilerschubert.pl'],
                phones: ['+48 58 682 16 57', '+48 505 848 406'],
                links: [
                    {
                        name: 'PARTNERS.links.configurator',
                        url: 'https://jubilerschubert.pl/konfigurator-obraczek-slubnych',
                    },
                ],
            },
            {
                name: '3 Stawy',
                country: 'Polska',
                postal_code: '40-028',
                city: 'Katowice',
                address: 'Pułaskiego 60',
                open: null,
                emails: ['3stawy@jubilerschubert.pl'],
                phones: ['+48 32 209 91 81', '+48 510 823 999'],
                links: [
                    {
                        name: 'PARTNERS.links.configurator',
                        url: 'https://jubilerschubert.pl/konfigurator-obraczek-slubnych',
                    },
                ],
            },
            {
                name: 'Marcelin',
                country: 'Polska',
                postal_code: '60-198',
                city: 'Poznań',
                address: 'Bukowska 156',
                open: null,
                emails: ['marcelin@jubilerschubert.pl'],
                phones: ['+48 61 88 60 160', '+48 695 186 586'],
                links: [
                    {
                        name: 'PARTNERS.links.configurator',
                        url: 'https://jubilerschubert.pl/konfigurator-obraczek-slubnych',
                    },
                ],
            },
            {
                name: 'Karolinka',
                country: 'Polska',
                postal_code: '45-837',
                city: 'Opole',
                address: 'Wrocławska 154',
                open: null,
                emails: ['karolinka@jubilerschubert.pl'],
                phones: ['+48 77 474 33 64', '+48 695 774 583'],
                links: [
                    {
                        name: 'PARTNERS.links.configurator',
                        url: 'https://jubilerschubert.pl/konfigurator-obraczek-slubnych',
                    },
                ],
            },
            {
                name: 'Manufaktura',
                country: 'Polska',
                postal_code: '91-066',
                city: 'Łódź',
                address: 'Jana Karskiego 5',
                open: null,
                emails: ['manufaktura@jubilerschubert.pl'],
                phones: ['+48 42 631 92 79', '+48 604 250 559'],
                links: [
                    {
                        name: 'PARTNERS.links.configurator',
                        url: 'https://jubilerschubert.pl/konfigurator-obraczek-slubnych',
                    },
                ],
            },
            {
                name: 'Korona',
                country: 'Polska',
                postal_code: '51-421',
                city: 'Wrocław',
                address: 'Krzywoustego 126',
                open: null,
                emails: ['korona@jubilerschubert.pl'],
                phones: ['+48 71 350 13 94', '+48 601 511 065'],
                links: [
                    {
                        name: 'PARTNERS.links.configurator',
                        url: 'https://jubilerschubert.pl/konfigurator-obraczek-slubnych',
                    },
                ],
            },
            {
                name: 'Bielany',
                country: 'Polska',
                postal_code: '55-040',
                city: 'Wrocław',
                address: 'Czekoladowa 6',
                open: null,
                emails: ['bielany@jubilerschubert.pl'],
                phones: ['+48 71 787 20 60', '+48 695 882 661'],
                links: [
                    {
                        name: 'PARTNERS.links.configurator',
                        url: 'https://jubilerschubert.pl/konfigurator-obraczek-slubnych',
                    },
                ],
            },
            {
                name: 'Platan',
                country: 'Polska',
                postal_code: '41-800',
                city: 'Zabrze',
                address: 'Plac Teatralny 10',
                open: null,
                emails: ['platan@jubilerschubert.pl'],
                phones: ['+48 32 271 12 68', '+48 503 705 309'],
                links: [
                    {
                        name: 'PARTNERS.links.configurator',
                        url: 'https://jubilerschubert.pl/konfigurator-obraczek-slubnych',
                    },
                ],
            },
            {
                name: 'Auchan',
                country: 'Polska',
                postal_code: '80-178',
                city: 'Gdańsk',
                address: 'Szczęśliwa 3',
                open: null,
                emails: ['auchan@jubilerschubert.pl'],
                phones: ['+48 500 387 796', '+48 693 306 301'],
                links: [
                    {
                        name: 'PARTNERS.links.configurator',
                        url: 'https://jubilerschubert.pl/konfigurator-obraczek-slubnych',
                    },
                ],
            },
            {
                name: 'Posnania',
                country: 'Polska',
                postal_code: '61-136',
                city: 'Poznań',
                address: 'Pleszewska 1',
                open: null,
                emails: ['posnania@jubilerschubert.pl'],
                phones: ['+48 61 646 31 97', '+48 669 444 412'],
                links: [
                    {
                        name: 'PARTNERS.links.configurator',
                        url: 'https://jubilerschubert.pl/konfigurator-obraczek-slubnych',
                    },
                ],
            },
            {
                name: 'Komorniki',
                country: 'Polska',
                postal_code: '60-004',
                city: 'Poznań',
                address: 'Głogowska 432',
                open: null,
                emails: ['komorniki@jubilerschubert.pl'],
                phones: ['+48 500 387 802', '+48 790 595 468'],
                links: [
                    {
                        name: 'PARTNERS.links.configurator',
                        url: 'https://jubilerschubert.pl/konfigurator-obraczek-slubnych',
                    },
                ],
            },
            {
                name: 'Krakowska',
                country: 'Polska',
                postal_code: '31-154',
                city: 'Kraków',
                address: 'Pawia 5',
                open: null,
                emails: ['krakowska@jubilerschubert.pl'],
                phones: ['+48 12 422 01 13', '+48 662 720 647'],
                links: [
                    {
                        name: 'PARTNERS.links.configurator',
                        url: 'https://jubilerschubert.pl/konfigurator-obraczek-slubnych',
                    },
                ],
            },
        ],
    },

    skorpion: {
        name: 'Jubiler Skorpion',
        logoURL: 'skorpion-logo.png',
        photo: 'skorpion-photo.JPG',
        website: 'https://jubilerskorpion.pl/',
        description: 'PARTNERS.skorpion_description',
        availableLanguages: ['pl', 'en', 'de', 'sk'],
        stores: [
            {
                name: 'DT Puchatek',
                country: 'Polska',
                postal_code: '',
                city: 'Kielce',
                address: 'ul. Sienkiewicza 33',
                open: null,
                emails: null,
                phones: ['+48 506 192 976'],
            },
            {
                name: 'Galeria ECHO',
                country: 'Polska',
                postal_code: '',
                city: 'Kielce',
                address: 'ul. świętokrzyska 20',
                open: null,
                emails: null,
                phones: ['+48 500 047 097'],
            },
            {
                name: 'Galeria AGORA',
                country: 'Polska',
                postal_code: '',
                city: 'Bytom',
                address: 'Pl. T. Kościuszki 1',
                open: null,
                emails: null,
                phones: ['+48 512 076 200'],
            },
            {
                name: 'Salon firmowy',
                country: 'Polska',
                postal_code: '',
                city: 'Kielce',
                address: 'ul. Sienkiewicza 40',
                open: null,
                emails: null,
                phones: ['+48 506 193 009'],
            },
            {
                name: 'Galeria KORONA',
                country: 'Polska',
                postal_code: '',
                city: 'Kielce',
                address: 'ul. Warszawska 26',
                open: null,
                emails: null,
                phones: ['+48 504 445 009'],
            },
            {
                name: '',
                country: 'Polska',
                postal_code: '',
                city: 'Tarnobrzeg',
                address: 'Pl. B. Głowackiego 30',
                open: null,
                emails: null,
                phones: null,
            },
            {
                name: 'DT Lotos',
                country: 'Polska',
                postal_code: '',
                city: 'Busko-Zdrój',
                address: 'Pl. Zwycięstwa 11/12',
                open: null,
                emails: null,
                phones: ['+48 500 047 762'],
            },
            {
                name: 'Galeria Staszowska',
                country: 'Polska',
                postal_code: '',
                city: 'Staszów',
                address: 'ul. Mickiewicza 62',
                open: null,
                emails: null,
                phones: ['+48 506 193 335'],
            },
            {
                name: 'Galeria Sfera 2',
                country: 'Polska',
                postal_code: '',
                city: 'Bielsko-Biała',
                address: 'ul. Mostowa 2',
                open: null,
                emails: null,
                phones: ['+48 512 020 656'],
            },
            {
                name: 'Galeria Słoneczna',
                country: 'Polska',
                postal_code: '',
                city: 'Radom',
                address: 'ul. Bolesława Chrobrego 1',
                open: null,
                emails: null,
                phones: ['+48 509 837 050'],
            },
            {
                name: 'Galeria INSPIRIO',
                country: 'Polska',
                postal_code: '',
                city: 'Opoczno',
                address: 'ul. M. Kopernika 1B',
                open: null,
                emails: null,
                phones: ['+48 797 455 110'],
            },
            {
                name: 'Galeria Jurajska',
                country: 'Polska',
                postal_code: '',
                city: 'Częstochowa',
                address: 'Al. Wojska Polskiego 207',
                open: null,
                emails: null,
                phones: ['+48 500 045 954'],
            },
        ],
    },
    terpilowski: {
        name: 'Jubiler Terpiłowski',
        logoURL: 'terpilowski-logo.png',
        photo: 'terpilowski-photo.png',
        website: 'https://sklep.terpilowski.com.pl',
        description: 'PARTNERS.terpilowski_description',
        availableLanguages: ['pl', 'en', 'de', 'sk'],
        stores: [
            {
                name: 'SKLEP INTERNETOWY',
                country: 'Polska',
                postal_code: '70-437',
                city: 'Szczecin',
                address: 'ul. Jagiellońska 16',
                open: null,
                emails: null,
                phones: ['+48 502 334 059'],
            },
            {
                name: 'CH GALAXY',
                country: 'Polska',
                postal_code: '',
                city: 'Szczecin',
                address: 'Aleja Wyzwolenia 18-20',
                open: null,
                emails: null,
                phones: ['+48 914 839 311'],
            },
            {
                name: 'CH Ster',
                country: 'Polska',
                postal_code: '',
                city: 'Szczecin',
                address: 'ul. Ku słoncu 67',
                open: null,
                emails: null,
                phones: ['+48 914 869 091'],
            },
            {
                name: 'CH Turzyn',
                country: 'Polska',
                postal_code: '',
                city: 'Szczecin',
                address: 'ul. Bohaterów Warszawy 42',
                open: null,
                emails: null,
                phones: ['+48 914 646 409'],
            },
            {
                name: 'GH Starówka',
                country: 'Polska',
                postal_code: '',
                city: 'Stargard',
                address: 'ul. Bolesława Chrobrego 8',
                open: null,
                emails: null,
                phones: ['+48 914 831 156'],
            },
        ],
    },
    sixSilver: {
        name: 'SixSilver',
        logoURL: 'six-silver-logo.png',
        photo: 'six-silver-photo.jpg',
        website: 'https://sixsilver.pl/',
        description: 'PARTNERS.sixsilver_description',
        availableLanguages: ['pl', 'en', 'de', 'sk'],
        stores: [
            {
                name: 'SixSilver Gliwice',
                country: 'Polska',
                postal_code: '44-100',
                city: 'Gliwice',
                address: 'ul. Zwycięstwa 1',
                open: {
                    week: '10-20',
                    saturday: '10-20',
                    sunday: '10-20',
                },
                emails: ['sklep@sixsilver.pl<br/> biuro@sixsilver.pl'],
                phones: ['+48 730-602-665', '+48 32 231 02 46'],
            },
            {
                name: 'SixSilver Bytom',
                country: 'Polska',
                postal_code: '41-902',
                city: 'Bytom',
                address: 'pl.Kościuszki 1',
                open: {
                    week: '9-21',
                    saturday: '9-21',
                    sunday: '10-20',
                },
                emails: null,
                phones: ['+48 730-602-666'],
            },
        ],
    },
    geselle: {
        name: 'Geselle Jubiler',
        logoURL: 'geselle-logo.png',
        photo: 'geselle-photo.jpg',
        website: 'https://www.geselle.pl/',
        description: 'PARTNERS.geselle_description',
        availableLanguages: ['pl', 'en', 'de', 'sk'],
        stores: [
            {
                name: 'GESELLE Jubiler Wrocław',
                country: 'Polska',
                postal_code: '50-006',
                city: 'Wrocław',
                address: 'ul. Kołłątaja 21',
                open: {
                    week: '10-18',
                    saturday: '10-14',
                },
                emails: ['jubiler@geselle.pl'],
                phones: ['+48 796 76 56 46'],
            },
            {
                name: 'GESELLE Jubiler Warszawa',
                country: 'Polska',
                postal_code: '02017',
                city: 'Warszawa',
                address: 'Al. Jerozolimskie 123a (Budynek Atlas Tower)',
                open: {
                    week: '10-18',
                    saturday: '10-14',
                },
                emails: ['warszawa@geselle.pl'],
                phones: ['+48 796 416 416'],
            },
        ],
    },
    amoro: {
        name: 'Amoro',
        logoURL: 'amoro.png',
        photo: 'amoro-photo.jpg',
        website: 'https://amoro.pl/',
        description: 'PARTNERS.amoro_description',
        availableLanguages: ['pl', 'en', 'de', 'sk'],
        stores: [
            {
                name: 'Amoro Showroom Jubilerski',
                country: 'Polska',
                postal_code: '95-100',
                city: 'Zgierz',
                address: 'Łódzka 4/6 Wejście D',
                open: {
                    everyday: '08:00-22:00',
                },
                emails: ['k.dziedzic@amoro.pl', 'kontakt@amoro.pl'],
                phones: ['+48 786 821 546'],
                note: 'PARTNERS.reservation_note',
            },
        ],
    },
    zeccoro: {
        name: 'Zeccoro',
        logoURL: 'zeccoro-logo.png',
        photo: 'zeccoro-photo.jpg',
        website: 'https://www.zeccoro.pl/',
        description: 'PARTNERS.zeccoro_description',
        availableLanguages: ['pl', 'en', 'de', 'sk'],
        stores: [
            {
                name: 'Salon Jubilerski Zeccoro',
                country: 'Polska',
                postal_code: '50-067',
                city: 'Wrocław',
                address: 'ul. Świdnicka 6A',
                open: {
                    week: '10:30-18:00',
                    saturday: '10:30-18:00',
                },
                emails: ['salon.wroclaw@zeccoro.pl'],
                phones: ['+48 797 009 677'],
            },
            {
                name: 'Salon Zeccoro Wroclavia',
                country: 'Polska',
                postal_code: '50-086',
                city: 'Wrocław',
                address: 'ul. Sucha 1',
                open: {
                    week: '9:00-21:00',
                    saturday: '9:00-21:00',
                },
                emails: ['wroclavia@zeccoro.pl'],
                phones: ['+48 797 487 559'],
            },
        ],
    },

    dubiel: {
        name: 'Jubiler Dubiel',
        logoURL: 'dubiel-logo.png',
        photo: 'dubiel-photo.jpg',
        website: 'https://jubilerdubiel.pl/',
        description: 'PARTNERS.dubiel_description',
        availableLanguages: ['pl'],
        stores: [
            {
                name: 'Jubiler Dubiel',
                country: 'Polska',
                postal_code: '43-300',
                city: 'Bielsko-Biała',
                address: 'ul. Dworkowa 2',
                open: null,
                emails: ['biuro@jubilerdubiel.pl'],
                phones: ['+48 509 556 747'],
            },
        ],
    },
};
